import { useTranslation } from 'react-i18next';
import { useRouter } from '@tanstack/react-router';
import { Rocket } from 'lucide-react';

export function useConfig() {
  const { t } = useTranslation();
  const router = useRouter();
  return {
    name: 'Evals',
    logo: <Rocket className='h-8 w-8 p-2' />,
    mainNav: [
      {
        title: t('navigation.datasets.title'),
        href: router.buildLocation({
          to: '/app/datasets',
        }),
        items: [
          {
            title: t('navigation.datasets.manage.title'),
            description: t('navigation.datasets.manage.description'),
            href: router.buildLocation({
              to: '/app/datasets',
            }),
          },
        ],
      },
      {
        title: t('navigation.agents.title'),
        href: router.buildLocation({
          to: '/app/agents/data-agent',
        }),
        items: [
          {
            title: t('navigation.agents.dataAgent.title'),
            description: t('navigation.agents.dataAgent.description'),
            href: router.buildLocation({
              to: '/app/agents/data-agent',
            }),
          },
          {
            title: t('navigation.agents.feedbackAgent.title'),
            description: t('navigation.agents.feedbackAgent.description'),
            href: router.buildLocation({
              to: '/app/agents/feedback-agent',
            }),
          },
        ],
      },
      {
        title: t('navigation.tracing.title'),
        href: router.buildLocation({
          to: '/app/tracing',
        }),
        items: [
          {
            title: t('navigation.tracing.chatAgent.title'),
            description: t('navigation.tracing.chatAgent.description'),
            href: router.buildLocation({
              to: '/app/tracing/chat-agent',
            }),
          },
          {
            title: t('navigation.tracing.dataAgent.title'),
            description: t('navigation.tracing.dataAgent.description'),
            href: router.buildLocation({
              to: '/app/tracing/data-agent',
            }),
          },
        ],
      },
      {
        title: t('navigation.playground.title'),
        href: router.buildLocation({
          to: '/app/threads',
        }),
        items: [
          {
            title: t('navigation.playground.chat.title'),
            description: t('navigation.playground.chat.description'),
            href: router.buildLocation({
              to: '/app/threads',
            }),
          },
        ],
      },
    ],
  };
}
